<div class="form" *appContactsAppContext>
  <div class="form-date">{{ group?.createdAt | dateFormat : 'date' }}</div>

  <h2 class="form-title">
    <app-icon
      class="form-heading-title-icon"
      name="groups"
      [style.color]="group?.color"
    />
    {{ group?.title }}
  </h2>

  @if (group) {
    <app-shared-tags
      class="form-tags"
      [stitchItem]="group"
      [stateKey]="StateKey.tagsList"
    />

    <app-shared-knots
      class="form-knots"
      [stitchItem]="group"
      [stateKey]="StateKey.knotsList"
    />
  }

  <app-shared-signup-cta />

  <div class="form-details">
    <div class="form-details-row">
      <div class="form-details-row-title">
        Parent Group
      </div>
      <div class="form-details-row-input">{{ group?.parentId }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Vip</div>
      <div class="form-details-row-input">{{ group?.vip }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">
        Country
      </div>
      <div class="form-details-row-input">{{ group?.country }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">
        Email
      </div>
      <div class="form-details-row-input">
        @for (email of group?.emails; track email.value) {
          <p>
            {{ email.category }}
            {{ email.value }}
          </p>
        }
      </div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">
        Phone Number
      </div>
      <div class="form-details-row-input">
        @for (phone of group?.phones; track phone.value) {
          <p>
            {{ phone.category }}
            {{ phone.value }}
          </p>
        }
      </div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">
        Address
      </div>
      <div class="form-details-row-input">{{ group?.address }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">
        Website
      </div>
      <div class="form-details-row-input">{{ group?.website }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">
        Description
      </div>
      <stch-item-description class="form-details-row-input" stchHighlightText [html]="group?.description" />
    </div>
  </div>
</div>
